var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"sticky-footer"},[_c('div',{staticClass:"text-center mt-2"},[_c('small',[_vm._v("Copyright © Linentech")])])])])
}]

export { render, staticRenderFns }